import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// ── Estilos ───────────────────────────────────────────────────────────────────
const styles = {
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '40px 24px',
    width: '100%',
    minHeight: '100%',
    boxSizing: 'border-box',
    margin: 0,
    overflow: 'hidden',
    borderRadius: 0,
    // El fondo  se define la clase
    // (survey.style / 'bg-white') pasada como className.
  },
  orb1: {
    position: 'absolute',
    borderRadius: '50%',
    filter: 'blur(40px)',
    opacity: 0.35,
    pointerEvents: 'none',
    width: 180,
    height: 180,
    top: -60,
    left: -60,
    background: '#1976d2',
  },
  orb2: {
    position: 'absolute',
    borderRadius: '50%',
    filter: 'blur(40px)',
    opacity: 0.35,
    pointerEvents: 'none',
    width: 160,
    height: 160,
    bottom: -50,
    right: -50,
    background: '#64b5f6',
  },
  logoWrap: {
    position: 'relative',
    zIndex: 1,
    width: 88,
    height: 88,
    borderRadius: '22px',
    background: '#ffffff',
    boxShadow: '0 8px 24px rgba(25, 118, 210, 0.18)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '24px',
  },
  logo: {
    width: 56,
    height: 56,
    objectFit: 'contain',
  },
  title: {
    position: 'relative',
    zIndex: 1,
    fontWeight: 700,
    color: '#1a1a2e',
    marginBottom: '12px',
  },
  titleHighlight: {
    color: '#1976d2',
  },
  description: {
    position: 'relative',
    zIndex: 1,
    color: '#5f6b7a',
    marginBottom: '32px',
    maxWidth: 320,
  },
  button: {
    position: 'relative',
    zIndex: 1,
    backgroundColor: '#1565c0',
    color: '#fff',
    borderRadius: '30px',
    padding: '14px 28px',
    fontWeight: 600,
    textTransform: 'none',
    fontSize: '1rem',
    maxWidth: 320,
    boxShadow: '0 8px 20px rgba(21, 101, 192, 0.35)',
    '&:hover': {
      backgroundColor: '#0d47a1',
      boxShadow: '0 10px 24px rgba(21, 101, 192, 0.45)',
    },
  },
};

// ── Componente ────────────────────────────────────────────────────────────────
const IntroSurvey = React.memo(
  ({
    title,
    titleHighlight,
    description,
    logoUrl,
    buttonText = 'Comenzar ahora',
    onStart,
    surveyStyle, // clase de fondo tomada de survey.style
  }) => (
    <Box
      className={surveyStyle ?? 'bg-white'}
      sx={styles.container}
    >
      {/* Orbs decorativos de fondo */}
      <Box sx={styles.orb1} aria-hidden="true" />
      <Box sx={styles.orb2} aria-hidden="true" />

      {/* Logo */}
      {logoUrl && (
        <Box sx={styles.logoWrap}>
          <Box
            component="img"
            src={logoUrl}
            alt="App logo"
            sx={styles.logo}
          />
        </Box>
      )}

      {/* Título */}
      <Typography variant="h4" component="h1" sx={styles.title}>
        {title}
        {titleHighlight && (
          <Box component="span" sx={styles.titleHighlight}>
            {' '}
            {titleHighlight}
          </Box>
        )}
      </Typography>

      {/* Descripción */}
      {description && (
        <Typography variant="body1" sx={styles.description}>
          {description}
        </Typography>
      )}

      {/* Botón de inicio */}
      <Button
        variant="contained"
        disableElevation
        endIcon={<ArrowForwardIcon />}
        onClick={onStart}
        fullWidth
        sx={styles.button}
      >
        {buttonText}
      </Button>
    </Box>
  )
);
IntroSurvey.displayName = 'IntroSurvey';

// ─────────────────────────────────────────────────────────────────────────────
// INSTRUCCIONES DE USO
// ─────────────────────────────────────────────────────────────────────────────
//
// import IntroSurvey from './IntroSurvey';
//
// <IntroSurvey
//   logoUrl="/nexus-logo.png"
//   title="Nexus"
//   titleHighlight="App"
//   description="Tu conexión inteligente con el mundo digital"
//   buttonText="Comenzar ahora"
//   surveyStyle={survey.style}
//   onStart={() => setStep('survey')}
// />
//
// ─────────────────────────────────────────────────────────────────────────────

export default IntroSurvey;